export const SETGENERALSEARCHLIST = "SETGENERALSEARCHLIST";
export const SETORDERSLIST = "SETORDERSLIST";
export const SETMYEQUIPMENTLIST = "SETMYEQUIPMENTLIST";
export const SETINVOICESLIST = "SETINVOICESLIST";
export const SETDELIVERIESLIST = "SETDELIVERIESLIST";
export const SETEQUIPMENTINFO = "SETEQUIPMENTINFO";
export const SETMETERBILLINGINFO = "SETMETERBILLINGINFO";
export const SETSERVICECALLINFO = "SETSERVICECALLINFO";
export const SETORDERHISTORYINFO = "SETORDERHISTORYINFO";